import addOn from '@/api/product/add-on'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState,
  product_type_id: 2,
	productRecipes: []
}

export const getters = {}

export const mutations = {
	...baseMutations,
	SET_PRODUCT_RECIPE(state, data){
		state.productRecipes = data
	},
	SET_PRODUCT_TYPE_ID(state, id){
		state.product_type_id = id
	},
	CLEAR_SETUP(state){
		state.productRecipes = []
	}
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          product_type_id: context.state.product_type_id,
          search: context.state.search
        }
      },
      attrubutes
    )
    return addOn.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  findProduct(context, id){
    return addOn.get({
      params: {
        filter: {
          product_id: id
        }
      }
    })
  },
  getProduct(context) {
    let params = Object.assign(
      {
        filter: {
          product_type_id: context.state.product_type_id
        }
      }
    )
    return addOn.product({ params })
  },
  store(context, data) {
    return addOn.store(data)
  },
  async getRecipe(context){
    return await addOn.recipe()
  }
}